export default __webpack_public_path__ + "static/media/hand.93a662f1.png";